export default {
  title: 'Import Mapping',
  importMappingModal: {
    title: 'Import {{ type }}',
    tabs: {
      import: {
        title: 'Import',
      },
      processing: {
        title: 'Processing',
      },
      previousImports: {
        title: 'Previous Imports',
      },
    },
    alerts: {
      minimumFields: {
        body: 'This import requires a minimum of {{ minFieldCount }} fields. Your file only contains {{ fieldCount }}.',
      },
      columnsNeedAssigning: {
        body: '{{ columnCount }} required columns need assigning.',
      },
      duplicateColumns: {
        body: 'Duplicate columns used for fields.',
      },
      columnsImported: {
        body: '{{ importedCount }} columns will be imported. {{ notImportedCount }} columns will not be imported.',
      },
    },
  },
  importSlide: {
    importInput: {
      label: 'Give a memorable name for this batch',
    },
    autoMatchToggle: {
      label: 'First row is column headers',
    },
  },
  previousImportsSlide: {
    table: {
      headers: {
        title: 'Title',
        date: 'Date',
        records: 'Records',
        successes: 'Successes',
        failures: 'Failures',
        warnings: 'Warnings',
        status: 'Status',
      },
    },
  },
  processingColumn: {
    noMatch: 'No Match Found',
    pleaseSelect: 'Please Select',
    moreRows: 'more rows',
  },
  processingSlide: {
    batchName: 'Batch name',
  },
};
